import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { zBom3PosSettings, ZBom3PosSettings } from "./ZBom3PosSettings";

const makeUrl = () => apiObjUrl(`/user-preferences/Bom3PositionsSettings`);

// появились требования к хранению ширины колонок.
// для каждого экземпляра бомпозишен может быть разный состав колонок, но большая часть совпадает
// поэтому все ширины привязываются к ИД колонки и хранятся независимо от экземпляра
// формат данных не меняется. но меняется ключ для доступа. раньше в него входил ИД экземпляра бом-позиции.
// теперь ключ общий для всех

export const saveBom3PositionSettings = async (
  settings: ZBom3PosSettings,
): Promise<void> => {
  await rest.post(makeUrl(), settings);
};

export const loadBom3PositionSettings =
  async (): Promise<ZBom3PosSettings | null> => {
    const resp = await rest.get(makeUrl());
    if (resp.data === "") return null;
    return zBom3PosSettings.parse(resp.data);
  };
